import { render, staticRenderFns } from "./TagSelectModal.vue?vue&type=template&id=5d7177a9&scoped=true&"
import script from "./TagSelectModal.vue?vue&type=script&lang=js&"
export * from "./TagSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./TagSelectModal.vue?vue&type=style&index=0&id=5d7177a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7177a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7177a9')) {
      api.createRecord('5d7177a9', component.options)
    } else {
      api.reload('5d7177a9', component.options)
    }
    module.hot.accept("./TagSelectModal.vue?vue&type=template&id=5d7177a9&scoped=true&", function () {
      api.rerender('5d7177a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/TagSelectModal.vue"
export default component.exports